<template>
  <div>
    <el-row style="height:500px">
      <el-col :span="10">
        <div class="grid-content bg-purple">关联菜单信息</div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content bg-purple-light">
          <div class="info">
            <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick" />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-button type="primary" @click="authorization">角色授权</el-button>
        </div>
      </el-col>
    </el-row>

  </div>
</template>
<script>
export default {
  data() {
    return {
      data: [{
        label: '一级 1',
        children: [{
          label: '二级 1-1',
          children: [{
            label: '三级 1-1-1'
          }]
        }]
      }, {
        label: '一级 2',
        children: [{
          label: '二级 2-1',
          children: [{
            label: '三级 2-1-1'
          }]
        }, {
          label: '二级 2-2',
          children: [{
            label: '三级 2-2-1'
          }]
        }]
      }, {
        label: '一级 3',
        children: [{
          label: '二级 3-1',
          children: [{
            label: '三级 3-1-1'
          }]
        }, {
          label: '二级 3-2',
          children: [{
            label: '三级 3-2-1'
          }]
        }]
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      }

    }
  },
  methods: {
    handleNodeClick(data) {
      console.log(data)
    },
    authorization() {
      this.$emit('returnResult')
    }
  }
}
</script>
<style lang="scss" scoped>
.info {
  border: 1px solid rgba(0, 0, 0, 0.15);
}
.el-col-10 {
  text-align: right;
  padding-right: 16px;
  padding-top: 8px;
  font-size: 14px;
  color:rgba(0,0,0,0.65)
}
.el-col-24{
  padding-top:8px ;
  border-top:1px solid #E8E8E8;
}
.el-button{
  border-radius: 4px;
}
.el-button--primary{
  float:right;
}
</style>
